//--------------------------------------------------
// imported classes
//--------------------------------------------------
const BaseMediator = require('./BaseMediator')
const ClassFunc = require('../util/ClassFunc')
const OrganizationSortTimeConvertor = require('../model/vo/OrganizationSortTime')

/**
 * The OrganizationMediator class maintains the business logic
 * for the organization.
 */
const tbs_controller_OrganizationMediator = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, BaseMediator, arguments)
    // console.log('tbs_controller_OrganizationMediator constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_controller_OrganizationMediator.prototype = {
    //--------------------------------------------------
    // api method
    //--------------------------------------------------
    handleCustomizedEvent: function(event) {
        if (event.type == 'itemClick') {
            // save the click behavior on the server side
            this.commitViewObjectData(new OrganizationSortTimeConvertor, {organizationId: event.data.organizationId}, null, 'update')
            this._bridge.goToScene('UserOrgManageOrganization', 
                {id: event.data.organizationId})
        }
        return true
    },
    handleCreateService: function(e) {
        console.log('handleCreateService', e)
        const self = this
        if (e.data.result == true) {
            const organizationId = e.data.payload.data.id
            this.commitViewObjectData(new OrganizationSortTimeConvertor, {organizationId: organizationId}, function() {
                self._bridge.goToScene('UserOrgManageOrganization', {id: organizationId})
            }, 'update')
        }
    },
    handleRemoveService: function() {
        this.exitPage()
    },
    handleRouteBack: function() {
        if (this._bridge.getRouteName() == 'UserOrgManageOrganization') {
            this.exitPage()
        }
        else if (this._bridge.getRouteName() == 'UserOrgCreateOrganization' && this._bridge.getRouteQuery('from') != 'UserOrgManageOrganization') {
            this.exitPage()
        }
        else {
            this._bridge.back()
        }
    }
}

//--------------------------------------------------
// extends the BaseMediator
//--------------------------------------------------
ClassFunc.extend(tbs_controller_OrganizationMediator, BaseMediator);

module.exports = tbs_controller_OrganizationMediator